import { SxProps, Theme } from '@mui/system';

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
  },

  label: {
    minWidth: '89px',
    fontWeight: 600,
    marginRight: '0.5rem',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
